/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { PropDB } from './prop-db';

/**
 *
 * @export
 * @interface UpdatePropEnvDto
 */
export class UpdatePropEnvDto {
    /**
     *
     * @type {PropDB}
     * @memberof UpdatePropEnvDto
     */
    env: PropDB;
    /**
     *
     * @type {string}
     * @memberof UpdatePropEnvDto
     */
    namespace: string;
}
